import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbService } from '../../services/common/breadcrumb.service';
import { CopyToClipboardComponent } from "../copy-to-clipboard/copy-to-clipboard.component";

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, CopyToClipboardComponent],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent {
  crumbs$ = inject(BreadcrumbService).breadcrumbs$;
}
